import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query";
import { getFromLocale, getSiteInfo } from "@/utils";


const { lang, curr, siteName } = getSiteInfo() ?? {}
export const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.API_URL}/api`,
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");
    headers.set("Accept", "application/json");
    headers.set("Authorization", `Bearer ${getFromLocale()}`);
    headers.set("Access-Control-Allow-Origin", "*");
    headers.set("Currency", `${curr}`);
    headers.set("Language", `${lang}`);
    headers.set("Referrer", siteName);
    return headers;
  },
});
